const translateContentfulPromoHeader = (promoConfig) => {
  const { backgroundColor, callToAction, heading, subheading } = promoConfig

  if (!heading && !subheading) {
    return null
  }

  return {
    ...promoConfig,
    ...(callToAction && {
      linkAriaLabel: callToAction.ariaLabel,
      linkUrl: callToAction?.longUrl || callToAction?.url,
      linkText: callToAction?.label,
    }),
    color: backgroundColor,
  }
}

export default translateContentfulPromoHeader
